import { cn } from "@/lib/cn";
import { useIntersectionObserver } from "usehooks-ts";
import { REGEX } from "../constants";

const Iframe = ({ link, isEditor }: { link: string; isEditor: boolean }) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
    freezeOnceVisible: true,
    rootMargin: "200px",
  });
  if (!REGEX.test(link)) return null;
  return (
    <iframe
      ref={ref}
      src={
        isIntersecting
          ? link.startsWith("https://")
            ? link
            : `https://${link}`
          : ""
      }
      title="URL link"
      tabIndex={-1}
      className={cn("tw-h-full tw-w-full tw-border-none", {
        "tw-pointer-events-none": isEditor,
      })}
    ></iframe>
  );
};

export default Iframe;
